// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/ticket.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'ticket',
  version: 'outline',
  paths: [
    {
      d: 'M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z',
    },
  ],
}
